
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edi-tram-plan",
      function () {
        return require("private-next-pages/edi-tram-plan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/edi-tram-plan"])
      });
    }
  